export default () => ({
  roles: [],
  role: {},
});
